module.exports = __webpack_public_path__ + "files/814e2e5ddb76c060b8e26b209db479e3.svg";